import Tippy from "@tippyjs/react";
import React from "react";

export default function Tooltip({children, trigger, placement, disabled, delay = [300, 0], content}) {
    return (
        <Tippy
            content={content}
            placement={placement}
            delay={delay}
            trigger={trigger}
            disabled={disabled}
        >
            {children}
        </Tippy>
    )
}